//https://tom-select.js.org/
import TomSelect from "tom-select";
import "tom-select/dist/css/tom-select.default.min.css";

window.addEventListener('load', function () {
    //Recherche par code postal sur la page d'accueil (-with-redirection) et sur le formulaire de pre-inscription
    let rechercheParCodePostalSelectElement = document.querySelector('.js-recherche-code-postal');

    if (rechercheParCodePostalSelectElement != null) {
        //Récupérer l'URL pour l'Ajax de WordPress, cette URL est passé en data du champ de recherche
        let adminAjaxUrl = rechercheParCodePostalSelectElement.getAttribute('data-admin-ajax-url');
        let defaultId = rechercheParCodePostalSelectElement.getAttribute('data-default-id');
        let defaultPostcode = rechercheParCodePostalSelectElement.getAttribute('data-default-postcode');
        let defaultCity = rechercheParCodePostalSelectElement.getAttribute('data-default-city');

        //Créer l'autocomplete
        if(rechercheParCodePostalSelectElement.classList.contains('-with-redirection')) {
            //Lorsque l'utilisateur choisi un résultat dans la recherche (sur la page d'accueil/complexe) :
            //On affiche les missions locales dans les résultats et on redirige vers une URL
            new TomSelect(rechercheParCodePostalSelectElement, {
                sortField: 'city',
                valueField: 'id',
                labelField: 'city',
                searchField: ['postcode', 'city'],
                maxOptions: 100,
                maxItems: 1,
                //Déclencher l'AJAX
                //TODO Mutualiser ?
                load: function (query, callback) {
                    //https://tom-select.js.org/examples/remote/ (Load Once)
                    let self = this;
                    //Déclencher l'appel qu'une fois
                    if (self.loading > 1) {
                        callback();
                        return;
                    }

                    //Appel Ajax WordPress
                    const data = new FormData();
                    //Définition de l'action à déclencher (ajax_communes est défini dans Bootstrap.php)
                    data.append('action', 'ajax_communes');

                    fetch(adminAjaxUrl, {
                        method: "POST",
                        body: data
                    })
                        .then(response => response.json())
                        .then(json => {
                            callback(json);
                            self.settings.load = null;
                        }).catch(() => {
                        callback();
                    });
                },
                render: {
                    //Item (quand il sera sélectionné)
                    item: function (data, escape) {
                        return `<div data-id="${escape(data['id'])}" data-url="${escape(data['url'])}">
                            ${escape(data['city'])} (${escape(data['postcode'])})
                        </div>`;
                    },
                    //Affichage dans la liste à sélectionner
                    option: function (data, escape) {
                        return `<div class="select-resultat">
                            <span class="ville">${escape(data['city'])} (${escape(data['postcode'])})</span>
                            <span class="mission-locale">${escape(data['name'])}</span>
                        </div>`;
                    },
                    no_results: function (data, escape) {
                        return '<div class="no-results">Aucun résultat trouvé</div>';
                    },
                },
                //Lorsqu'unn item est sélectionné
                onItemAdd: function (value, $item) {
                    //Récupération de l'URL (défini en data dans item) sur laquelle on doit rediriger l'utilisateur
                    window.location.href = $item.getAttribute('data-url');
                }
            });
        } else {
            let tomSelectControl = new TomSelect(rechercheParCodePostalSelectElement, {
                sortField: 'city',
                valueField: 'id',
                labelField: 'city',
                searchField: ['postcode', 'city'],
                maxOptions: 100,
                maxItems: 1,
                plugins: {
                    remove_button:{
                        title:'Retirer',
                    }
                },
                //Déclencher l'AJAX
                //TODO Mutualiser ?
                load: function (query, callback) {
                    //https://tom-select.js.org/examples/remote/ (Load Once)
                    let self = this;
                    //Déclencher l'appel qu'une fois
                    if (self.loading > 1) {
                        callback();
                        return;
                    }

                    //Appel Ajax WordPress
                    const data = new FormData();
                    //Définition de l'action à déclencher (ajax_communes est défini dans Bootstrap.php)
                    data.append('action', 'ajax_communes');

                    fetch(adminAjaxUrl, {
                        method: "POST",
                        body: data
                    })
                        .then(response => response.json())
                        .then(json => {
                            callback(json);
                            self.settings.load = null;
                        }).catch(() => {
                        callback();
                    });
                },
                render: {
                    //Item (quand il sera sélectionné)
                    item: function (data, escape) {
                        return `<div data-id="${escape(data['id'])}" data-city="${escape(data['city'])}" data-postcode="${escape(data['postcode'])}">
                            ${escape(data['city'])} (${escape(data['postcode'])})
                        </div>`;
                    },
                    //Affichage dans la liste à sélectionner
                    option: function (data, escape) {
                        return `<div class="select-resultat">
                            <span class="ville">${escape(data['city'])} (${escape(data['postcode'])})</span>
                        </div>`;
                    },
                    no_results: function (data, escape) {
                        return '<div class="no-results">Aucun résultat trouvé</div>';
                    },
                }
            });

            if(defaultId != null) {
                //Source : https://github.com/orchidjs/tom-select/discussions/240#discussioncomment-4153170
                //tomSelectControl.addOption({ id: 0, city: 'Rechercher un code postal', postcode: 'ou une ville'});
                tomSelectControl.addOption({ id: defaultId, city: defaultCity, postcode: defaultPostcode});
                tomSelectControl.addItem(defaultId);
            }
        }
    }

}, false);